"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAttributeDistribution = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const use_attribute_distribution_query_1 = require("./use-attribute-distribution.query");
const client_constants_1 = require("../../../client/client.constants");
const client_utils_1 = require("../../../client/client.utils");
const sortModelToApiSort = (sortModel) => {
    if (sortModel.length === 0)
        return undefined;
    const { field, sort } = sortModel[0];
    return { [field]: sort === 'asc' ? 'Asc' : 'Desc' };
};
const useAttributeDistribution = ({ catalogId, productTreeId, productTreeNodeId, sortModel, searchQuery, }) => {
    const sort = (0, react_1.useMemo)(() => sortModelToApiSort(sortModel), [sortModel]);
    const { data, error, networkStatus, refetch: apolloRefetch, variables, } = (0, react_2.useQuery)(use_attribute_distribution_query_1.GET_CATALOG_ATTRIBUTE_DISTRIBUTION, {
        variables: {
            ids: [catalogId],
            productTreeId,
            productTreeNodeId,
            sort,
            first: client_constants_1.PAGE_SIZE_DEFAULT,
            before: null,
            after: null,
            last: null,
            search: searchQuery,
        },
        skip: !catalogId || !productTreeId,
        notifyOnNetworkStatusChange: true,
    });
    const refetch = (0, react_1.useCallback)((variables) => __awaiter(void 0, void 0, void 0, function* () {
        yield apolloRefetch(variables);
    }), [apolloRefetch]);
    const normalizedData = (0, react_1.useMemo)(() => {
        var _a, _b, _c, _d, _e, _f;
        const { pageInfo, totalCount, edges: attributes = [] } = (_f = (_e = (_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.catalogs) === null || _a === void 0 ? void 0 : _a.edges) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.node) === null || _d === void 0 ? void 0 : _d.statistics) === null || _e === void 0 ? void 0 : _e.attributes) !== null && _f !== void 0 ? _f : {};
        const normalizedAttributes = attributes.map(({ node: { dimensions: { attribute }, applied, notApplicable, total, unknown, }, }) => ({
            id: attribute,
            attribute,
            applied,
            notApplicable,
            total,
            unknown,
        }));
        return {
            attributes: normalizedAttributes,
            pageInfo,
            totalCount: totalCount || 0,
        };
    }, [data]);
    const onSearch = (0, react_1.useCallback)((newSearchTerm) => {
        void apolloRefetch({
            search: newSearchTerm || undefined,
            before: null,
            after: null,
        });
    }, [apolloRefetch]);
    return {
        data: normalizedData,
        error,
        isLoading: (0, client_utils_1.isQueryLoading)(networkStatus),
        refetch,
        pageInfo: normalizedData.pageInfo,
        totalCount: normalizedData.totalCount,
        onSearch,
        lastVariables: variables,
    };
};
exports.useAttributeDistribution = useAttributeDistribution;
